import { createStyle } from '@gluestack-style/react';

export const StatusBar = createStyle({});
